import { createAsyncThunk } from '@reduxjs/toolkit';

import { SliceNameEnum } from '@app/enums';
import { AccommodationStateModel, RequestAdditionalParamsModel } from '@app/models';
import { QueryAccommodationArgs } from '@app/models/api/api-types';

export const fetchAccommodation = createAsyncThunk(
    `${SliceNameEnum.Accommodation}/fetch-accommodations`,
    async (
        args: (Partial<QueryAccommodationArgs> & RequestAdditionalParamsModel) | undefined,
        { getState },
    ) => {
        const { AccommodationService } = await import('@app/services/accommodation.service');
        const { extraParams, ...queryArgs } = args ?? {};
        const state = getState() as { [SliceNameEnum.Accommodation]: AccommodationStateModel };
        const stateFilters = state[SliceNameEnum.Accommodation]?.filters;
        const filters = { ...stateFilters, ...(queryArgs ?? {}) };

        return await AccommodationService.instance.loadEntity(
            filters as QueryAccommodationArgs,
            extraParams?.headers,
        );
    },
);
